export default __webpack_public_path__ + "static/media/logo_utente.fc3f7a30.png";